export default class PrinterException extends Error {
    constructor(message: string) {
        super(message);
    }
}
